export default __webpack_public_path__ + "static/operations-c278dc6ffcf7c9959a905b664c8bdbc3.webp";